import { NgModule } from '@angular/core';

import { provideConfig } from '@spartacus/core';

import {
  COMMON_ACCESSORY_FEATURE, COMMON_ACCOUNT_FEATURE, COMMON_CART_FEATURE, COMMON_PRODUCT_COMPARATOR_FEATURE,
  COMMON_CATEGORY_FEATURE, COMMON_PRODUCT_FEATURE, COMMON_SEARCH_FEATURE, COMMON_RECIPES_FEATURE
} from '../../constants/common-features';

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        [COMMON_ACCOUNT_FEATURE]: {
          module: () => import('@seb/web-common/account/web-common-account.module').then((m) => m.WebCommonAccountModule)
        },
        [COMMON_CART_FEATURE]: {
          module: () => import('@seb/web-common/cart/web-common-cart.module').then((m) => m.WebCommonCartModule)
        },
        [COMMON_PRODUCT_FEATURE]: {
          module: () => import('@seb/web-common/product/web-common-product.module').then((m) => m.WebCommonProductModule)
        },
        [COMMON_ACCESSORY_FEATURE]: {
          module: () => import('@seb/web-common/accessory/web-common-accessory.module').then((m) => m.WebCommonAccessoryModule)
        },
        [COMMON_PRODUCT_COMPARATOR_FEATURE]: {
          module: () => import('@seb/web-common/product-comparator/web-common-product-comparator.module').then((m) => m.WebCommonProductComparatorModule)
        },
        [COMMON_CATEGORY_FEATURE]: {
          module: () => import('@seb/web-common/category/web-common-category.module').then((m) => m.WebCommonCategoryModule)
        },
        [COMMON_SEARCH_FEATURE]: {
          module: () => import('@seb/web-common/search/web-common-search.module').then((m) => m.WebCommonSearchModule)
        },
        [COMMON_RECIPES_FEATURE]: {
          module: () => import('@seb/web-common/recipes/web-common-recipes.module').then((m) => m.WebCommonRecipesModule)
        }
      }
    })
  ]
})
export class CommonFeatureModule {}
